
import React,{Component} from "react"
import Topnav from "../../components/topnav/topnav";
import {connect} from "react-redux"
import Footer from "../../components/footer/footer";
import {Redirect} from "react-router-dom"
import ReactGA from 'react-ga';
import { Row, Col, Button } from "antd";
import {Helmet} from "react-helmet";
import {proPlanPrice,basicPlanPrice} from "../../../../../config/fbConfig"

class Pricing extends Component{
    constructor(props){
        super(props)
        this.state={
          pricingPlans: [
            { id: 1, title: 'free', package:"Monthly", price: 0, users: 4, storage: 2 },
            { id: 3, title: 'pro',  package:"Yearly", price: proPlanPrice, users: 12, storage: 7 },
            { id: 2, title: 'basic', package:"Monthly", price: basicPlanPrice, users: 8, storage: 5 },
          ]
        }
    }

    componentDidMount() {
        window.fbq('track', 'Lead');
    }   
  
    goto = (plan)=>{
    var {history} =this.props
    // ReactGA.initialize('UA-141254607-1');
     if(plan.title ==="free"){ 
        history.push(`/signup`)
        window.fbq('track', 'InitiateCheckout', {
            value: 0,
            currency: 'USD',
        });
        ReactGA.event({
            category: 'User',
            action: 'Initiate Checkout',
            label: 'User Interaction',
            value: 0
        });
     }
     else{
    //  var token = jwt.sign(plan,"1864")
    //  history.push(`/pay?token=${token}`)
        // history.push(`/subscriptions?plan=${plan.package.toLowerCase()}&token=${token}`)
        history.push(`/subscriptions?plan=${plan.package.toLowerCase()}`)
        window.fbq('track', 'InitiateCheckout', {
            value: plan.price,
            currency: 'USD',
        });
        ReactGA.event({
            category: 'User',
            action: 'Initiate Checkout',
            label: 'User Interaction',
            value: plan.price
        });
     }
   }

render(){
   var {pricingPlans} = this.state
   
    return(
        this.props.profile.isEmpty?
        <div className="pricing">
          <Helmet>
          <title>Pricing</title>
          <meta name="description" content="Scale at your own pace and pay for what you need" />
        </Helmet>
            <Topnav {...this.props} />
                {/* <section className="xheader">
                   <Row>
                       <Col sm={24} lg={6} ></Col>
                       <Col sm={24} lg={12}>
                       <h1 >  Find the perfect plan for you  </h1>
                      <p>Scale at your own pace and pay for what you need</p>
                       </Col>
                       <Col sm={24} lg={6} ></Col>
                   </Row>
                </section> */}
                <div className="xcontent">
                {/* <Row type="flex" justify="center">
                    <Col  sm={24} lg={{span:16}}>
                     <div className="xtitle">
                     <h1 >  Find the perfect plan for you  </h1>
                      <p>Scale at your own pace and pay for what you need</p>
                    </div>
                    </Col>
                </Row> */}
                    <Row type="flex"  justify="center">
                    {pricingPlans.map((plan,key)=>(
                      <Col className="no-padding" key={key} xs={24} sm={24} md={plan.title==="pro"?7:6} lg={plan.title==="pro"?8:6}>
                        <div className="xbox">
                            <div className={`pricing-card ${plan.title}`}>
                                <div className="header">
                                    {plan.title==="pro"?<h3 className='open-sans2'>Professional</h3>
                                    :<h4 className='open-sans2'>{plan.title}</h4>
                                    }
                                    {plan.title==="pro"&&
                                    <p>Learn the best JavaScript tools and frameworks from industry pros.
                                    </p>}
                                    {plan.title==="basic" &&<p>Learn JavaScript like your career depends on it</p>
                                    }
                                    {plan.title==="free"&&<p>
                                    Ready to get Started? Learn something new today
                                    </p>}
                                    <p >Starting at</p>
                                    <p className="price">${plan.price}<span>/{plan.title==="pro"?"yr":"mo"}</span></p>
                                </div>
                                <center><Button onClick={()=>this.goto(plan)}>Select Package</Button></center>
                                <hr />
                                <div className="xbody">
                                <p>{plan.users} users included</p>
                                <p>{plan.storage} GB of storage</p>
                                <p>Email Support</p>
                                <p>Help center access</p>
                                </div>
                            </div>
                        </div>
                    </Col>
                    ))}
                    </Row>
                </div>
            <Footer />
        </div>:  <Redirect to="/" />
    )
}
}

const mapStateToProps = (state)=>{
    return{
        auth:state.auth,
        profile:state.firebase.profile
    }
}
const mapDispatchToProps = null;
export default connect(mapStateToProps,mapDispatchToProps)(Pricing)